import client from '../client';
import * as companiesQueries from "../queries/company";
import * as companiesMutations from "../mutations/company";

export function getCompanies(success, error, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        query: companiesQueries.all,
    })
    .then(success)
    .catch(error);
}


export function add(success, error, data) {
    client.mutate({
        variables: { company: data },
        mutation: companiesMutations.add,
    }).then(success).catch(error);
}


export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, company: data },
        mutation: companiesMutations.edit,
    })
    .then(success)
    .catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/company.js